import React from 'react';

export default function GsrdWch() {
    // 项目名统一追加 WCH 上角标，避免各页面手写样式不一致
    return (
        <span className="gsrd-wch-name">
            GSRD-100K<sup className="gsrd-wch-mark">WCH</sup>
        </span>
    );
}
